import state from './moduleDataState.js'
import mutations from './moduleDataMutations.js'
import actions from './moduleDataActions.js'
import getters from './moduleDataGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
